import React, {Component, Fragment} from "react";

import {Button, DialogActions, DialogContent, Typography, Tabs, Tab, Box} from "@material-ui/core";

import {v4 as uuid} from "uuid";
import buildUrl from "build-url";

import {withTranslation} from "react-i18next";

import CloseableDialog from "./closeable";

import {SubscriptionStatus, SubscriptionActions} from "./subscription";

class TabPanel extends Component {
    render = () => {
        var {value, index, children} = this.props;
        return <div hidden={value!=index}>
            {value == index &&
                <Box>
                    <Typography>{children}</Typography>
                </Box>
                }
        </div>
        }
    }

class LoginDialog extends Component {
    constructor (props, context) {
        super(props, context);

        var state = {
            stateGuid: uuid(),
            email: null,
            hmac: null,
            session: null,
            level: null,
            curPanel: 0,
            keepDialog: false
            }

        this.state = state;
        }

    componentDidMount = () => {

        window.addEventListener("storage", (e) => {
            try {
                if (e.key == "packerSubscriptionUpdate") {
                    var msg = JSON.parse(e.newValue);

                    this.handleServerMsg(msg);
                    }

                } catch (e) {};

            });

        if (this.props.silentLogin) {
            this.silentLogin();
            }
        }

    handleServerMsg = (msg) => {
        console.log("handleServerMsg", msg);
        console.log("state", this.state);

        switch (msg.op) {
            case "login":
                this.getUserData(msg.email, msg.hmac);
                break;

            case "subscribed":
                this.getUserData(this.state.email, this.state.hmac);
                break;

            default:
                break;
            }
        }

    getUserData = (email, hmac) => {
        console.log("getUserData", email, hmac);
        if (email) {
            var userUrl = buildUrl(this.props.host, {path: "user/" + email, queryParams: {hmac: hmac} });

            fetch(userUrl)
                .then((response) => response.json())
                .then((result) => {
                    this.userDataReceived(result);
                    });
            }
        }

    userDataReceived = (msg) => {
        console.log("userData", msg);
        var {keepDialog} = this.state;

        this.setState({keepDialog:false, curPanel: 1, ...msg});
        var active = msg.subscriptionActive | msg.trialActive;

        var {loginComplete} = this.props;

        if (active) {
            this.props.root.setState({accessToken: msg.session, level: msg.level}, () => {loginComplete(msg, keepDialog)});
            } else {
            this.props.root.setState({accessToken:undefined, level: msg.level});
            }
        }

    silentLogin = () => {
        var cookieLoginUrl = buildUrl(this.props.host, {path:"cookieLogin"})

        fetch(cookieLoginUrl)
            .then((response) => response.json())
            .then((result) => {
                this.userDataReceived(result);
                });
        }

    onGoogleLogin = () => {
        this.setState({keepDialog: true});

        var redirectUrl = buildUrl(this.props.host, {path: "connectBack", queryParams: {state: this.state.stateGuid}});

        var url = buildUrl(this.props.host, {path: "login", queryParams: {cont: redirectUrl, error: redirectUrl, state: this.state.stateGuid}});
        window.localStorage.setItem("packerSubscriptionUpdate", "{}");
        window.open(url);
        }

    onLogout = () => {
        var logoutUrl = buildUrl(this.props.host, {path:"logout"})

        fetch(logoutUrl);

        this.setState({email: undefined, session: undefined, trialActive: false, subscriptionActive: false});
        this.props.root.setState({accessToken: undefined});
        }

    onPortal = () => {
        var {host} = this.props;
        var {session, stateGuid} = this.state;

        var redirectUrl = buildUrl(host, {path: "done", queryParams: {state: stateGuid}});
        var portalUrl = buildUrl(host, {path: "portal/"+ session, queryParams: {done: redirectUrl, error: redirectUrl}});
        window.localStorage.setItem("packerSubscriptionUpdate", "{}");

        window.open(portalUrl);
        }

    onChange = (evt, newValue) => {
        this.setState({curPanel: newValue});
        }

    render = () => {

        var {open, loginComplete, t, host, email, hmac, allowLogout} = this.props;
        var hmacProp = hmac;
        var {subscriptionActive, trialActive, trialEnd, stateGuid, session, level, curPanel, hmac} = this.state;

        var dialogTitle = t("Login");

        if (email) {
            if (!this.state.email) {
                this.getUserData(email, hmacProp);
                }
            }

        if (this.state.email) {
            dialogTitle = t("Subscription")
            }

        return <CloseableDialog open={open} onClose={loginComplete} dialogTitle={dialogTitle}>
            {!this.state.email &&
                <Fragment>
                    <DialogContent>
                        <Typography variant="body">
                            <p>{t("You need to login to use the 3D Packer.")}</p>
                            <p>{t("We will give you a free 30 day test period. After that, you will need an active subscription.")}</p></Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={this.onGoogleLogin} color="primary">{t("Login with Google")}</Button>
                    </DialogActions>

                </Fragment>}

            {this.state.email &&
                <Fragment>
                    <DialogContent>
                        <Tabs value={curPanel} onChange={this.onChange}>
                            <Tab label={t("Subscription")} value={0}></Tab>
                            <Tab label={t("Status")} value={1}></Tab>
                        </Tabs>
                        <TabPanel value={curPanel} index={0}>
                            <SubscriptionActions subscriptionActive={subscriptionActive} session={session} signalGuid={stateGuid} host={host} />
                        </TabPanel>
                        <TabPanel value={curPanel} index={1}>
                            <SubscriptionStatus email={this.state.email} subscriptionActive={subscriptionActive} trialActive={trialActive} trialEnd={trialEnd} level={level} hmac={hmac}/>
                        </TabPanel>
                    </DialogContent>
                    <DialogActions>
                        {subscriptionActive &&
                            <Button variant="contained" onClick={this.onPortal} color="primary">{t("Manage subscription")}</Button>
                            }
                        {allowLogout &&
                            <Button variant="contained" onClick={this.onLogout}>{t("Logout")}</Button>
                            }
                    </DialogActions>
                </Fragment>}
        </CloseableDialog>;
        }
    }

LoginDialog = withTranslation()(LoginDialog);

export default LoginDialog;